import type { FC } from "react";
import "./index.less";
import { Layout, theme as antTheme } from "antd";
import { Suspense, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import MenuComponent from "./menu";
import HeaderComponent from "./header";
import { LocalStorage } from "../../utils/convertData";
import { AppDispatch } from "../../stores";
import { mockMenuListAdmin } from "../../mock/user/menu.mock";
import { loginSuccess } from "../../stores/authSlice";

const { Sider, Content } = Layout;

const LayoutPage: FC = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const token = antTheme.useToken();

  const [role, setRole] = useState<number | null>(null);
  const [selectedKey, setSelectedKey] = useState(location.pathname);
  const [openKey, setOpenKey] = useState<string>();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userString = localStorage.getItem("user");

    if (!token || !userString) {
      navigate("/login");
      return;
    }

    try {
      const user = JSON.parse(userString);
      const userRole = user?.role?.[0] ?? null;

      if (userRole !== null) {
        dispatch(loginSuccess({ token, user }));
        setRole(userRole);
      } else {
        navigate("/login");
      }
    } catch (error) {
      navigate("/login");
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    setSelectedKey(location.pathname);
  }, [location.pathname]);

  const handleMenuChange = (key: string) => {
    setSelectedKey(key);
  };

  const filteredMenu = mockMenuListAdmin.filter((menu) =>
    Array.isArray(menu.roles) ? menu.roles.includes(role!) : true
  );

  return (
    <Layout className="layout-page">
      <HeaderComponent collapsed={true} />
      <Layout>
        <Sider
          className="layout-page-sider"
          trigger={null}
          width={250}
          collapsible
          collapsed={false}
          style={{ backgroundColor: token.token.colorBgContainer }}
          breakpoint="md">
          {role !== null && (
            <MenuComponent
              menuList={filteredMenu}
              openKey={openKey}
              onChangeOpenKey={(k) => setOpenKey(k)}
              selectedKey={selectedKey}
              onChangeSelectedKey={handleMenuChange}
            />
          )}
        </Sider>
        <Content
          className="layout-page-content"
          style={{ height: "93vh", padding: "10px" }}>
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutPage;
